import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Table from "../../Components/Table";
import _ from "lodash";
import { CardBody, Button, Col } from "reactstrap";
import { Icon } from "semantic-ui-react";
import { Transfer } from "antd";
import TemplateForm from "./Forms/template";
import { connect } from "react-redux";
import Axios from "axios";
import createModal from "../../Components/ModalV2";
import Loader from "../../../Global/Loader";
import ContentWrapper from "../../../template/Layout/ContentWrapper";
import { openNotification } from "../../Components/Notification";

import { Services } from "../../../../repositories/clients/Services";
import { withNamespaces } from "react-i18next";

class InfoAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalAlert: false,
      typeAlert: "",
      messageAlert: "",
      isMovil: false,
      tableEntityConf: [
        // { label: "ID", key: "EntityId" },
        { label: "ID", key: "EntityId" },
        { label: this.props.t("company_name"), key: "Nombre" },
        { label: this.props.t("phone"), key: "Telephone" },
        { label: this.props.t("country"), key: "Country" },
      ],
      alertId: this.props.match ? this.props.match.params.id : -1,
      loadingInfo: true,
      entityTable: "",
      entityCatalog: [],
      selectedEntities: [],
      data: {},
    };
  }

  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    this.setState({
      isMovil: isMobileDevice,
    });

    this.init();
  };

  init = async () => {
    await this.getAlertInfo();
    await this.getEntityCatalog();
    await this.generateInfo();

    this.setState({ checkedList: [], modalIsOpen: false, loadingInfo: false });
  };

  generateInfo = async () => {
    let { data, entityTable, generalInfo, selectedEntities } = this.state;
    if (data) {
      if (data.CustomersId) {
        entityTable = this.generateEntityTable(data.CustomersId.split(","));
        selectedEntities = data.CustomersId.split(",").map((cust) => {
          cust = parseInt(cust);
          return cust;
        });
      }
      generalInfo = this.generateGeneralInfo(data);
    }
    this.setState({ entityTable, generalInfo, selectedEntities });
  };

  generateGeneralInfo = (data) => {
    let generalInfo = TemplateForm["previewForm"].map((e) => {
      var attrInfo = "";
      var extraClass = "";

      if (e.type === "label") {
        attrInfo = <span className="label-euro">{data[e.id]}</span>;
      }
      return (
        <div className={e.class} style={{ paddingTop: "1%" }}>
          {
            <div className="row">
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                <span className="label-euro" style={{ fontWeight: "bold" }}>
                  {this.props.t(e.label)}
                </span>
              </div>
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                {attrInfo}
              </div>
            </div>
          }
        </div>
      );
    });
    return generalInfo;
  };

  getAlertInfo = async () => {
    const { lng, _user } = this.props;
    let { alertId } = this.state;
    try {
      const response = await Axios.post(
        `${Services.ADMIN.path}alerts/getInfoAlert`,
        {
          alertId,
          lng,
          userId: _user
        }
      );

      this.setState({
        data: response.data.alert,
      });

    } catch (error) {
      console.error("Error al obtener detalle de alerta:", error);
    }
  };

  getEntityCatalog = async () => {
    let { entityCatalog } = this.state;
    try {
      let resp = await Axios.get(`${Services.ADMIN.path}admin/entities`);
      entityCatalog = this.sortCatalogs(resp.data.clientes, "text");
      this.setState({ entityCatalog });
    } catch (ex) {
      console.error(ex);
    }
  };

  generateEntityTable = (EntitiesIds) => {
    let { entityCatalog } = this.state;
    var arrayEntity = [];
    EntitiesIds.map((entId) => {
      entityCatalog.map((catEnt) => {
        if (entId == catEnt.key) {
          arrayEntity.push(catEnt.data);
        }
      });
    });
    arrayEntity.sort((a, b) => a.Nombre.localeCompare(b.Nombre));

    return (
      <Table
        columns={this.state.tableEntityConf}
        data={arrayEntity}
        itemsByPage={5}
        rowClick={false}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
          pagination: true,
          search: true,
        }}
      />
    );
  };
  cambiaEdicion = () => {
    let { data, selectedEntities } = this.state;
    if (data) {
      if (data.CustomersId) {
        selectedEntities = data.CustomersId.split(",").map((cust) => {
          cust = parseInt(cust);
          return cust;
        });
      }
    }
    this.setState({ isEdit: true, selectedEntities });
  };

  //### Agregar o desasignar #########

  sortCatalogs = (array, attr) => {
    array.sort((a, b) => a[attr].localeCompare(b[attr]));
    return array;
  };
  filterOption = (a, b, c) => {
    return b.label.toLowerCase().indexOf(a.toLowerCase()) > -1;
  };

  cancelEdit = () => {
    let { data } = this.state;
    this.setState({
      isEdit: false,
      selectedEntities: data.CustomersId.split(","),
    });
  };
  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  saveEdit = async () => {
    let { selectedEntities, alertId } = this.state;
    let data = {
      AlertId: alertId,
      Entities: selectedEntities,
    };
    try {
      this.setState({ loadingInfo: true }, async () => {
        await Axios.put(`${Services.ADMIN.path}alerts/editAlert`, data);
        openNotification('success', this.props.t("alert_update_succesful"));
        this.sleep(1500).then(() => {
          this.props.history.push("/alerts-notifications");
        });
      });
    } catch (ex) {
      console.error(ex);
    }
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index && value != null && value != "";
  };

  handleChangeFilter = (nextTargetKeys, direction, moveKeys) => {
    let { selectedEntities } = this.state;
    if (selectedEntities) {
      if (direction === "left") {
        moveKeys.forEach((key) => {
          var removeKey = selectedEntities.indexOf(key);
          if (removeKey > -1) {
            selectedEntities.splice(removeKey, 1);
          }
        });
        // this.setState({ modalAlert: true, typeAlert: "success", messageAlert: this.props.t("retired") })
      } else {
        moveKeys.forEach((key) => {
          selectedEntities.push(key);
        });
        // this.setState({ modalAlert: true, typeAlert: "success", messageAlert: this.props.t("added") })
      }

      selectedEntities = selectedEntities.filter(this.onlyUnique);
    } else {
      // this.setState({ modalAlert: true, typeAlert: "success", messageAlert: this.props.t("added") })
      selectedEntities = moveKeys;
    }

    this.setState({ selectedEntities });
  };
  //###################################

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    let {
      isEdit,
      loadingInfo,
      entityTable,
      generalInfo,
      entityCatalog,
      selectedEntities,
      isMovil,
      modalAlert,
      typeAlert,
      messageAlert
    } = this.state;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-alerts-notifications icon-header" />
          {this.props.t("alert_notifications")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/alerts-notifications")}
              />
            </Icon.Group>
            <span
              className="label-back"
              onClick={() => this.props.history.push("/alerts-notifications")}
            >
              {this.props.t("back")}
            </span>
          </div>
        </div>
        <div className={!isMovil ? "card myCard" : ""}>
          <Col xs={12}>
            <CardBody>
              <div className="row">
                <div className="col-8">
                  <span className="euro-title-form">
                    {this.props.t("alert_detail")}
                  </span>
                </div>
                <div className="ml-auto">
                  {isEdit ? (
                    false
                  ) : (
                    <span
                      className="icon-edit icons-front-module"
                      onClick={() => this.cambiaEdicion()}
                      title={this.props.t("edit")}
                    ></span>
                  )}
                </div>
              </div>
              <div className="row" style={{ marginTop: "35px" }}>
                {generalInfo}
              </div>
              {isEdit ? (
                <div>
                  {/* <div className='row'> */}
                  <Transfer
                    style={{
                      marginTop: "25px",
                      width: "100%",
                      // maxWidth: "90%",
                      justifyContent: "center",
                      height: "350px",
                    }}
                    locale={{
                      itemUnit: this.props.t("company"),
                      itemsUnit: this.props.t("companies"),
                      searchPlaceholder: "",
                    }}
                    dataSource={this.state.entityCatalog}
                    showSearch
                    filterOption={this.filterOption}
                    onChange={this.handleChangeFilter}
                    render={(item) => item.label}
                    operations={[
                      this.props.t("add"),
                      this.props.t("eliminate"),
                    ]}
                    targetKeys={selectedEntities}

                  // showSelectAll={false}
                  />
                  {/* </div> */}
                  <div className="row" style={{ marginTop: "15px" }}>
                    <div className="col-6">
                      <Button
                        color="secondary"
                        className="float-right custom-width-btn"
                        onClick={this.cancelEdit}
                      >
                        {this.props.t("cancel")}
                      </Button>
                    </div>
                    <div className="col-6">
                      <Button
                        color="primary"
                        className="button float-left custom-width-btn"
                        onClick={this.saveEdit}
                      >
                        {this.props.t("save")}
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: "45px" }}>{entityTable}</div>
              )}

              {/* </div> */}
            </CardBody>
          </Col>

          {/* </Card> */}
        </div>
        {createModal({
          isModalOpen: modalAlert,
          titleModal: typeAlert !== 'error' ? 'Success' : 'Error',
          type: typeAlert,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{messageAlert}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("Ok"),
              onClick: () => this.setState({ modalAlert: false }),
              type: "primary",
            }
          ],
          onCancel: () => this.setState({ modalAlert: false })
        })}
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(InfoAlert)));
